/**
 * Text gallery carousel: prev/next arrow navigation.
 * Runs per [data-text-gallery] section that has a track and multiple slides.
 */
function initTextGallery(section) {
  const track = section.querySelector('[data-text-gallery-track]');
  if (!track) return;

  const slides = section.querySelectorAll('[data-text-gallery-slide]');
  const prevBtn = section.querySelector('[data-text-gallery-prev]');
  const nextBtn = section.querySelector('[data-text-gallery-next]');
  const total = slides.length;

  if (total <= 1) return;

  let current = 0;

  function goTo(index) {
    current = (index + total) % total;
    slides.forEach((slide, i) => {
      slide.classList.toggle('text-gallery__slide--active', i === current);
      slide.setAttribute('aria-hidden', i !== current);
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));
}

function initTextGalleries() {
  document.querySelectorAll('[data-text-gallery]').forEach((section) => {
    if (section.querySelector('[data-text-gallery-track]')) {
      initTextGallery(section);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTextGalleries);
} else {
  initTextGalleries();
}
